// UNBRECEIVED TRANS REDUCER

import {UnreceivedAction} from "../actions/Unreceived";

const initState = {
  isLoading: false,
  isLoaded: false,
  transactions: [],
  totalTrans: 0,
  totalAmount: 0,
};

const unreceivedTransReducer = (state = initState, action) => {
  switch (action.type) {
  case UnreceivedAction.LOAD_UNRECEIVED_TRANS:
    return {
      ...state,
      isLoading: true,
    };

  case UnreceivedAction.LOAD_UNRECEIVED_TRANS_SUCCESS:
    return {
      ...state,
      isLoaded: true,
      isLoading: false,
      transactions: Object.assign([], action.transactions),
      totalTrans: action.totalTrans,
      totalAmount: action.totalAmount,
    };

  case UnreceivedAction.LOAD_UNRECEIVED_TRANS_FAIL:
    return {
      ...state,
      isLoaded: false,
      isLoading: false,
      transactions: [],
      totalTrans: 0,
      totalAmount: 0,
    };

  case UnreceivedAction.RESET_UNRECEIVED_TRANS:
    return {
      ...state,
      ...initState,
    };

  default:
    return state;
  }
};

export default unreceivedTransReducer;
